import React from "react";
import PVDesignManager from "./PVDesignManager";
import PVDesignRemovePVsBox from "./PVDesignRemovePVsBox";
import PVDesignControls from "./PVDesignControls";
import PVDesignCart from "./PVDesignCart";
import PVRooftopPolygonsSelectionConfirmationBox from "./PVRooftopPolygonsSelectionConfirmationBox";
import { useSelector } from "react-redux";

const PVDesignRoot = () => {
  const { isPVDesignActive } = useSelector((state) => state.pvDesign);

  if (!isPVDesignActive) return null;
  return (
    <>
      <PVDesignManager />
      <PVDesignRemovePVsBox />
      <PVDesignControls />
      <PVDesignCart />
      <PVRooftopPolygonsSelectionConfirmationBox />
    </>
  );
};

export default PVDesignRoot;


